import React from "react";
import "./App.css";
import { Principal } from "./Pages/Principal";

function App() {
  // Coloca esta instrucción donde desees establecer la cookie con SameSite=Lax
  return (
    <div className="App">
      <Principal />
    </div>
  );
}

export default App;
